'use client'

import { PropsWithChildren, useEffect } from 'react'

const ScrollToTop = (props: PropsWithChildren) => {
  useEffect(() => {
    window.history.scrollRestoration = 'manual'
  }, [])

  return props.children
}

export default ScrollToTop
